<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  getList,
  del,
  save,
  getConfig,
  expenseItem
} from "@/api/endTripManage/ClearanceQuotationRule";
import cTable from "@/base/common/index";
import Fields from "./fields";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getCountry } from "@/api/system/country";
import { getCurrency } from "@/api/finance/currency";
/* import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getChargingType } from "@/api/double/list";
import { getConfig,getSubjectCost } from "@/api/tracker/cost_page"; */
export default {
  name: "ClearanceQuotationRule",
  components: {
    cTable
  },
  async created() {
    this.configs = (await getConfig()).data.payload;
    this.client = (await getAllClient()).data.payload.rows;
    this.currency = (await getCurrency()).data.payload.rows;
    let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
    let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    this.configs.id = (await expenseItem()).data.payload.rows.map(t => {
      return {
        label: t.name,
        value: t.id
      };
    });
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id") item.options = this.client;
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
    });
    this.modals.add.fields.forEach(async item => {
      if (item.key === "client_id") item.options = this.client;
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
      if (item.key === "clearance_type")
        item.options = this.configs.clearance_type;
      if (item.key === "manifest_type")
        item.options = this.configs.clearance_type;
      if (item.key === "max_tax_type") item.options = this.configs.max_tax_type;
      if (item.key === "tax_type") item.options = this.configs.tax_type;
      if (item.key === "currency") item.options = this.currency;
      if (item.fields) {
        item.fields.forEach(t => {
          t.options = this.configs[t.key];
        });
      }
    });
  },
  methods: {},
  data() {
    let that = this;
    return {
      configs: {},
      client: [],
      companies: [],
      unit: [],
      bubble: [],
      currencyList: [],
      SubjectCost: [],
      methods: {
        list(params) {
          if (params.target_type === 2) {
            params.client_id = params.company_id;
          }
          return getList(params);
        },
        del,
        save,
        getConfig
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, fields, close }) {
              row.details = this.list;
              console.log(fields);
              fields.forEach(t => {
                if (t.fields) {
                  let result = [];
                  row[t.key].forEach(data => {
                    if (Object.keys(data).length === 0) return;
                    let isTrue = t.fields.find(t => t.required && !data[t.key]);
                    if (!isTrue) result.push(data);
                  });
                  row[t.key] = result;
                }
              });
              this.$page.handleRequestMethods("save", row, true).then(e => {
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              styles: {
                top: "30px"
              },
              width: 900
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              from_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              clearance_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              start_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date"
                }
              ],
              end_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date"
                }
              ]
            }
          },
          grid: [
            { client_id: 24 },
            { from_country: 12, to_country: 12 },
            { start_time: 12, end_time: 12 },
            { currency: 24 },
            { manifest_type: 24 },
            { manifest_price: 24 },
            { clearance_type: 24 },
            { clearance_price: 24 },
            { tax_type: 8, min_value: 8, tax_price: 8 },
            { max_tax_type: 24 },
            { max_tax_price: 24 },
            { other_fee: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: this.$t("otherCost"),
              key: "other_fee",
              fields: [
                {
                  key: "id",
                  component: "Select",
                  placeholder: this.$t("alipay_name"),
                  required: true
                },
                {
                  key: "fee",
                  component: "Input",
                  placeholder: this.$t("cost_t"),
                  required: true
                }
              ],
              render: (h, p) => {
                if (!p.row[p.field.key].length) {
                  p.row[p.field.key].push({});
                }

                return h(Fields, {
                  attrs: {
                    data: p,
                    fields: p.field.fields
                  }
                });
              },
              default: []
            },
            {
              name: this.$tz("MANIFEST FEE计算规则"),
              key: "manifest_price",
              fields: [
                {
                  key: "min",
                  component: "Input",
                  placeholder: this.$t("Min Extent")
                },
                {
                  key: "max",
                  component: "Input",
                  placeholder: this.$t("Max Extent")
                },
                {
                  key: "charge_type",
                  component: "Select",
                  placeholder: this.$t("Charge Mode")
                },
                {
                  key: "fee",
                  component: "Input",
                  placeholder: this.$t("doublePrice")
                }
              ],

              render: (h, p) => {
                if (!p.row[p.field.key].length) {
                  p.row[p.field.key].push({});
                }

                return h(Fields, {
                  attrs: {
                    data: p,
                    fields: p.field.fields
                  }
                });
              },
              default: []
            },
            {
              name: this.$tz("高额税费计费规则"),
              key: "max_tax_price",
              type: 1,
              fields: [
                {
                  key: "min",
                  component: "Input",
                  placeholder: this.$t("Min Extent")
                },
                {
                  key: "max",
                  component: "Input",
                  placeholder: this.$t("Max Extent")
                },
                {
                  key: "charge_type",
                  component: "Select",
                  placeholder: this.$t("Charge Mode")
                },
                {
                  key: "fee",
                  component: "Input",
                  placeholder: this.$t("doublePrice")
                }
              ],
              render: (h, p) => {
                if (!p.row[p.field.key].length) {
                  p.row[p.field.key].push({});
                }

                return h(Fields, {
                  attrs: {
                    data: p,
                    fields: p.field.fields
                  }
                });
              },
              default: []
            },
            {
              name: this.$t("clearanceFee"),
              key: "clearance_price",
              type: 1,
              fields: [
                {
                  key: "min",
                  component: "Input",
                  placeholder: this.$t("Min Extent")
                },
                {
                  key: "max",
                  component: "Input",
                  placeholder: this.$t("Max Extent")
                },
                {
                  key: "charge_type",
                  component: "Select",
                  placeholder: this.$t("Charge Mode")
                },
                {
                  key: "fee",
                  component: "Input",
                  placeholder: this.$t("doublePrice")
                }
              ],
              render: (h, p) => {
                if (!p.row[p.field.key].length) {
                  p.row[p.field.key].push({});
                }
                return h(Fields, {
                  attrs: {
                    data: p,
                    fields: p.field.fields
                  }
                });
              },
              default: []
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3
              }
            },
            {
              key: "client_id",
              name: () => this.$t("b2bClient"),
              component: "Select",
              placeholder: data => {
                return this.$t("select") + this.$t("b2bClient");
              },
              options: [],
              config: {
                label: "account",
                value: "id"
              }
            },
            {
              key: "from_country",
              name: () => this.$t("allow_depart"),
              component: "Select",
              placeholder: this.$t("select") + this.$t("allow_depart"),
              options: [],
              config: {
                label: "code",
                value: "code"
              }
            },
            {
              key: "to_country",
              name: () => this.$t("allow_arrive"),
              component: "Select",
              placeholder: this.$t("select") + this.$t("allow_arrive"),
              options: [],
              config: {
                label: "code",
                value: "code"
              }
            },
            {
              key: "currency",
              name: () => this.$t("currency_t"),
              component: "Select",
              placeholder: this.$t("select") + this.$t("currency_t"),
              options: [],
              config: {
                label: "title",
                value: "code"
              }
            },
            {
              key: "manifest_type",
              name: () => this.$tz("MANIFEST FEE类型"),
              component: "Select",
              placeholder: this.$tz("MANIFEST FEE类型"),
              options: []
            },
            {
              key: "max_tax_type",
              name: () => this.$tz("高额税费类型"),
              component: "Select",
              placeholder: this.$tz("高额税费类型"),
              options: []
            },
            {
              key: "clearance_type",
              name: () => this.$t("clearance_fee_type"),
              component: "Select",
              placeholder: this.$t("select") + this.$t("clearance_fee_type"),
              options: []
            },
            {
              key: "tax_type",
              name: () => this.$t("billingVAT") + this.$t("mode"),
              component: "Select",
              placeholder:
                this.$t("select") + this.$t("billingVAT") + this.$t("mode"),
              options: []
            },
            {
              name: this.$t("billingVAT") + this.$t("ratio"),
              key: "tax_price",
              component: "Input",
              placeholder: () => this.$t("billingVAT") + this.$t("ratio")
            },
            {
              name: this.$tz("最低收税点"),
              key: "min_value",
              component: "Input",
              placeholder: () => this.$tz("最低收税点")
            },
            {
              key: "start_time",
              name: () => this.$t("rule") + this.$t("startingTime"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "date"
              },
              placeholder() {
                return (
                  this.$t("select") + this.$t("rule") + this.$t("startingTime")
                );
              }
            },
            {
              key: "end_time",
              name: () => this.$t("rule") + this.$t("endTime"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "date"
              },
              placeholder() {
                return this.$t("select") + this.$t("rule") + this.$t("endTime");
              }
            },
            {
              key: "transport_fee",
              name: () => this.$t("transport_fee"),
              component: "InputNumber",
              bind: {
                style: "width:100%"
              },
              default: 0,
              placeholder() {
                return this.$t("enter") + this.$t("transport_fee");
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder: data => {
              return this.$t("select") + this.$t("b2bClient");
            },
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "from_country",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            }
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            }
          }
          // {
          //   key: "keywords",
          //   placeholder() {
          //     return this.$t("keyword");
          //   },
          //   bind: {
          //     type: "textarea",
          //     rows: 1,
          //   },
          //   component: "Input",
          // },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              fnName: "add",
              type: "add",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            add() {
              this.getModal("add").open({}, function() {
                this.setTitle(this.$t("add"));
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: this.$t("b2bClient"),
          key: "customer",
          minWidth: 120
        },

        {
          name: this.$t("allow_depart"),
          key: "from_country",
          minWidth: 120
        },
        {
          name: this.$t("allow_arrive"),
          key: "to_country",
          minWidth: 120
        },
        {
          name: this.$t("startingTime"),
          key: "start_time",
          minWidth: 120
        },
        {
          name: this.$t("endTime"),
          key: "end_time",
          minWidth: 120
        },
        {
          name: this.$t("currency_t"),
          key: "currency",
          minWidth: 120
        },
        {
          name: this.$t("clearance_fee_type"),
          key: "clearance_type_txt",
          minWidth: 120
        },
        {
          name: this.$t("clearanceFee"),
          key: "clearance_price_txt",
          minWidth: 120
        },
        {
          name: this.$tz("MANIFEST FEE计算规则"),
          key: "manifest_price_txt",
          minWidth: 120
        },
        {
          name: this.$tz("最低收税点"),
          key: "min_value",
          minWidth: 120
        },
        {
          name: this.$tz("高额税费类型"),
          key: "max_tax_type_txt",
          minWidth: 120
        },
        {
          name: this.$tz("高额税费计费规则"),
          key: "max_tax_price_txt",
          minWidth: 120
        },
        {
          name: this.$t("taxFee") + this.$t("type"),
          key: "tax_type_txt",
          minWidth: 120
        },
        {
          name: this.$t("TaxesUnitPrice"),
          key: "tax_price",
          minWidth: 120
        },
        {
          name: this.$t("otherCost"),
          key: "other_fee_txt",
          minWidth: 120
        },
        {
          name: this.$t("Remarks"),
          key: "remarks",
          minWidth: 120
        },
        {
          name: this.$t("createTime"),
          key: "create_time",
          minWidth: 120
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              }
              // id:1258
            },
            {
              name: () => this.$tz("复制"),
              type: "copy",
              fnName: "copy",
              bind: {
                type: "success"
              }
              // id:1258
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              }
              // id:1259
            }
          ],
          methods: {
            copy({ row }) {
              this.modals.add.fields.forEach(item => {
                if (item.fields) {
                  if (Array.isArray(row[item.key][0])) {
                    row[item.key] = [];
                  }
                }
              });
              this.getModal("add").open(
                Object.assign(row, { id: "" }),
                function() {
                  this.setTitle(this.$t("update"));
                }
              );
            },
            async updateFun({ row }) {
              this.modals.add.fields.forEach(item => {
                if (item.fields) {
                  if (Array.isArray(row[item.key][0])) {
                    row[item.key] = [];
                  }
                }
              });
              this.getModal("add").open(row, function() {
                this.setTitle(this.$t("update"));
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") + this.$t("confirm") + this.$t("delete"),
                onOk: () => {
                  this.handleRequestMethods("del", row, true).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped></style>
